import { ACTION_TYPES } from './store/actions';
import { accountApi } from '../api';
import { IAccount, ViewConfigResponse } from '../model/account.model';
import { mapToObject } from '../ui/tools/methods';
import { useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';

export const next = viewConfig => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_VIEW_CONFIG_RESPONSE,
    payload: accountApi.nextApi(viewConfig),
  });
};

export const findSubscription = (verifList?: any) => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT,
    payload: accountApi.findSubscription(),
  });

  if (verifList) verifList(((await getState().account.subcriptionNotAttachedList) || []).filter(s => s.valid === false));
};

export const findSubscriptionBySubNumebr = (subNumber: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_SUBSCRIPTION_BY_SUB_NUMBER,
    payload: accountApi.findSubscriptionByNumber(subNumber),
  });
};

// GET_SUBSCRIPTION_BY_SUB_NUMBER: 'account/GET_SUBSCRIPTION_BY_SUB_NUMBER',

export const verifyScriptionByNumber = (subNumber: string, mode: string, value: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.VERIFY_SUBSCRIPTION,
    payload: accountApi.verifyScriptionByNumber(subNumber, mode, value),
  });
};

export const verifyOTP = (subNumber: string, mode: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.VERIFY_OTP,
    payload: accountApi.verifyOTP(subNumber, mode),
  });
};

export const verifyOTPCode = (subNumber: string, value: string, mode: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.VERIFY_OTP_CODE,
    payload: accountApi.verifyOTPCode(subNumber, value, mode),
  });
};

export const verifySpecific = (subscriptionNumber, value, mode) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.VERIFY_SPECIFIC,
    payload: accountApi.verifyScriptionByNumber(subscriptionNumber, value, mode),
  });
};

export const emptySlectedContract = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.EMPTY_FOUND_SUBSCRIPTION,
  });
};

export const cleanViewConfigResponse = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.CLEAN_VIEW_CONF,
  });
};

export const cleanNumberVerified = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.CLEAN_NUMBER_VERIFIED,
  });
};

export const updateGlobalObject = (viewName, viewObject, attributParam) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.UPDATE_VIEW_OBJECT,
    payload: { viewObject, viewName, attributParam },
  });
};

export const verifPreviousMail = (adhesionNumber, mail) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.VERIF_PREVIOUS_MAIL,
    payload: accountApi.verifPreviousMail(adhesionNumber, mail),
  });
};
